export default __webpack_public_path__ + "static/media/ic-pdf.fad22eea.svg";